import { State } from '../../reducers/rootReducer'
import EquipmentGroup from '../../../entities/EquipmentGroup'

const equipmentGroupsForCarlineAndModelSelector = (state: State): EquipmentGroup[] => state.equipmentGroupsForCarlineAndModel

export default equipmentGroupsForCarlineAndModelSelector
